import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-content-layout-wrapper',
  templateUrl: './content-layout-wrapper.component.html',
  styleUrls: ['./content-layout-wrapper.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ContentLayoutWrapperComponent {
  constructor() {}
}
